module.exports = __webpack_public_path__ + "qaumi-white-5e0729ba414772c0d223.svg";